// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://trpzvpfjdwtfoiavbmjg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRycHp2cGZqZHd0Zm9pYXZibWpnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQ4MTYwODAsImV4cCI6MjA1MDM5MjA4MH0.OKaRgw7brg5hrdo0_qI5PXyf3KQeiKhwOCp1mAjFyso";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);